import { render, staticRenderFns } from "./InformativeDashboard.vue?vue&type=template&id=2a4c66e9"
import script from "./InformativeDashboard.vue?vue&type=script&lang=js"
export * from "./InformativeDashboard.vue?vue&type=script&lang=js"
import style0 from "./InformativeDashboard.vue?vue&type=style&index=0&id=2a4c66e9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports